export default () => Boolean(navigator.share)
